var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rzo-cross-connect',{on:{"ticketCreated":function($event){return _vm.$router.push({ name: 'tasks', params: { selectedTaskId: $event.id }})}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }